/**
 * Указываем тут условие с проверкой на даты, если в данный момент проходит маркетинговая акция.
 * Обычно временно заменяется иконка трипкоина возле раздела "Отели" на новую иконку распродажи.
 * Последнее актуальное промо - {@link https://jira.twiket.com/browse/FI-1038|Задача}
 */
const CURRENT_DATE = new Date();
const END_OF_PROMO = new Date('2024-11-30 23:59:00');
export const IS_MARKETING_PROMO_AVAILABLE = CURRENT_DATE < END_OF_PROMO;
